<template>
  <div class="notifications-component">
    <div class="table-component">
      <div class="row">
        <div class="col-sm-12">
          <div class="card card-primary">
            <div class="card-header">
              <span class="fa fa-bell fa-fw"></span>
              Notifications <span class="badge badge-info">{{ userNotificationsCount }}</span>
              <button class="btn btn-danger btn-xs float-right" @click="dismissAll()">
                <span class="fa-times fa"></span> Dismiss All
              </button>
              <button class="btn btn-primary btn-xs float-right snooze" @click="snoozeAll()">
                <span class="fa-bell-slash fa"></span> Snooze All
              </button>
            </div>
            <div class="card-body p-0">
              <div class="list-group list-group-flush">
                <div class="list-group-item" :key="notification.uuid" v-for="notification in userNotifications">
                  <em class="pull-right" v-if="notification.snoozed">Snoozed</em>
                  <p>
                    <span :class="notification.snoozed ? 'fa fa-bell-slash' : 'fa fa-bell'"></span> <strong>{{ notification.name }}</strong>
                  </p>
                  <p v-html="notification.message"></p>
                  <p>
                    <strong>Created:</strong> {{ notification.startTime | short_date_time_format }}
                  </p>
                  <p>
                    <strong>Expires:</strong> {{ notification.endTime | short_date_time_format }}
                  </p>
                  <button class="btn btn-primary btn-xs" @click="dismiss(notification)">
                    <span class="fa-times fa"></span> Dismiss
                  </button>
                  <button v-if="!notification.snoozed" class="btn btn-primary btn-xs" @click="snooze(notification)">
                    <span class="fa-bell-slash fa"></span> Snooze
                  </button>
                </div>
                <template v-if="!userNotificationsCount">
                  <p class="alert alert-success">
                    <span class="fa fa-check fa-fw"></span> You currently do not have any notifications
                  </p>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  LOAD_NOTIFICATIONS,
  SNOOZE_NOTIFICATION,
  SNOOZE_NOTIFICATIONS,
  DISMISS_NOTIFICATIONS,
  DISMISS_NOTIFICATION
} from '@/vuex/types'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Notifications',
  computed: {
    ...mapGetters([
      'userNotifications',
      'userNotificationsCount'
    ])
  },
  async mounted () {
    await this.$store.dispatch(LOAD_NOTIFICATIONS)
  },
  methods: {
    async executeAction (action, payload) {
      await this[action](payload)
    },
    dismiss (notification) {
      this.executeAction(DISMISS_NOTIFICATION, notification)
    },
    snooze (notification) {
      this.executeAction(SNOOZE_NOTIFICATION, notification)
    },
    snoozeAll () {
      this.executeAction(SNOOZE_NOTIFICATIONS)
    },
    dismissAll () {
      this.executeAction(DISMISS_NOTIFICATIONS)
    },
    ...mapActions([
      SNOOZE_NOTIFICATION,
      SNOOZE_NOTIFICATIONS,
      DISMISS_NOTIFICATIONS,
      DISMISS_NOTIFICATION
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/Notifications.vue